var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"contenteditable":_vm.editable},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"input":function($event){return _vm.updateValue($event.target.innerHTML)}}})}
var staticRenderFns = []

export { render, staticRenderFns }